import { useRecoilTransactionObserver_UNSTABLE } from 'recoil'
import {
  isEditorProbeArmed,
  recordEditorProbeRecoilWrite,
} from '@/utils/editor/editorProbe'

const RecoilWriteRecorder = () => {
  useRecoilTransactionObserver_UNSTABLE(({ snapshot }) => {
    const keys: string[] = []
    for (const node of snapshot.getNodes_UNSTABLE({ isModified: true }))
      keys.push(node.key)
    recordEditorProbeRecoilWrite(keys)
  })
  return null
}

export const EditorProbeRecoilObserver = () =>
  isEditorProbeArmed() ? <RecoilWriteRecorder /> : null

export default EditorProbeRecoilObserver
